export interface YesNoOption {
  value: string;
  label: string;
}

export const YesNoOptions = (): Array<YesNoOption> => [
  {
    label: "Da",
    value: "Da",
  },
  {
    label: "Ne",
    value: "Ne",
  }
]

export interface YesNoMostlyOption {
  value: string;
  label: string;
}

export const YesNoMostlyOptions = (): Array<YesNoMostlyOption> => [
  {
    label: "Da",
    value: "Da",
  },
  {
    label: "Uglavnom",
    value: "Uglavnom da",
  },
  {
    label: "Ne",
    value: "Ne",
  }
]
